import { NavLink } from 'react-router';
import { LayoutDashboard, CalendarDays, CalendarRange, ClipboardList, Users, Menu } from 'lucide-react';
import { useUiStore } from '../store/ui.js';
import { useBureauAccess, useBureauMe } from '../api/bureau.js';

// Bottom tab bar shown only on mobile (<768px, see the MOBILE LAYER in
// global.css). The four everyday destinations get one-tap access; the
// fifth tab opens the full drawer (same nav as the desktop sidebar) for
// everything else. Visibility of the four tabs needs no permission
// check — none of these routes carry a perm/module restriction in
// Sidebar.tsx.

const TABS = [
  { to: '/dashboard', label: 'Tableau', Icon: LayoutDashboard },
  { to: '/entry', label: 'Saisie', Icon: CalendarDays },
  { to: '/monthly', label: 'Grille', Icon: CalendarRange },
  { to: '/employees', label: 'Employés', Icon: Users },
] as const;

// La responsable du bureau (réglage Bureau → Personnes) a « Bureau » en
// premier onglet, à la place d'Employés qui reste dans le menu.
const BUREAU_TAB = { to: '/bureau', label: 'Bureau', Icon: ClipboardList } as const;

export function MobileNav() {
  const setDrawerOpen = useUiStore((s) => s.setDrawerOpen);
  const access = useBureauAccess();
  const bme = useBureauMe(access.view);
  const assignee = !!bme.data?.isAssignee;
  const tabs = assignee ? [BUREAU_TAB, ...TABS.slice(0, 3)] : TABS;
  const urgent = assignee ? bme.data?.urgent ?? 0 : 0;

  return (
    <nav className="mobile-nav" aria-label="Navigation mobile" data-testid="mobile-nav">
      {tabs.map(({ to, label, Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) => (isActive ? 'mobile-nav-item active' : 'mobile-nav-item')}
        >
          <Icon aria-hidden="true" />
          <span>{label}</span>
          {to === '/bureau' && urgent > 0 && <span className="mobile-nav-badge">{urgent}</span>}
        </NavLink>
      ))}
      <button
        type="button"
        className="mobile-nav-item"
        onClick={() => setDrawerOpen(true)}
        data-testid="mobile-nav-menu"
      >
        <Menu aria-hidden="true" />
        <span>Menu</span>
      </button>
    </nav>
  );
}
